import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Grid,
    // Button,
    Paper,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    tableCellClasses,
    Divider,
} from "@mui/material";
import { FiDownload } from "react-icons/fi";
import { Add, Edit as EditIcon } from "@mui/icons-material";
import { FontFamily } from "assets";
import { v4 as uuidv4 } from "uuid";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";
import InputField from "components/Input";
import instance from "config/axios";
import routes from "services/System/routes";
import InputPhone from "components/InputPhone";
import { emailRegex } from "utils";
import Colors from "assets/Style/Colors";
import { PrimaryButton } from "components/Buttons";
import { SuccessToaster, ErrorToaster } from "components/Toaster";
import DatePicker from "components/DatePicker";
import SupplierServices from "services/Supplier";
import CheckIcon from "@mui/icons-material/Check";
import {
    CleanTypes,
    getFileSize,
} from "utils";
import SelectField from "components/Select";
import UploadFile from "components/UploadFile";
import BankServices from "services/Bank";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";


const CustomPaper = styled(Paper)(({ theme }) => ({
    gap: 0,
}));

const Row = styled(TableRow)(({ theme }) => ({
    border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        border: 0,
        textAlign: "left",
        whiteSpace: "nowrap",
        backgroundColor: Colors.primary,
        color: Colors.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        textAlign: "left",
        textWrap: "nowrap",

        ".MuiBox-root": {
            display: "flex",
            gap: "6px",
            alignItems: "center",
            justifyContent: "center",
            ".MuiBox-root": {
                cursor: "pointer",
            },
        },
        svg: {
            width: "auto",
            height: "24px",
        },
        ".MuiTypography-root": {
            textTransform: "capitalize",
            fontFamily: FontFamily.NunitoRegular,
            textWrap: "nowrap",
        },
        ".css-1ru1j9e-MuiTableCell-root ": {
            color: "#ffffff",
            textAlign: "left",
        },
        ".MuiButtonBase-root": {
            padding: "8px",
            width: "28px",
            height: "28px",
        },
    },
}));

// Helper: red border style for invalid fields
const errorBorderSx = {
    "& .MuiOutlinedInput-root": {
        "& fieldset": { borderColor: "red" },
        "&:hover fieldset": { borderColor: "red" },
        "&.Mui-focused fieldset": { borderColor: "red" },
    },
    "& .MuiInputLabel-root": { color: "red" },
};

function EditSupplier() {
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        resetField,
        control,
    } = useForm();

    const navigate = useNavigate();
    const { id } = useParams();
    const [activeStep, setActiveStep] = useState(0);
    const [loader, setLoader] = useState(false);
    const [licenseDate, setLicenseDate] = useState(new Date());
    const [selectedDocumentType, setSelectedDocumentType] = useState("");
    const [selectedBank, setSelectedBank] = useState("");
    const [banks, setBanks] = useState([]);
    const [documentList, setDocumentList] = useState([]);
    const [documentLink2, setDocumentLink2] = useState("");
    const [progress2, setProgress2] = useState(0);
    const [uploadedSize2, setUploadedSize2] = useState(0);
    const [documentDetail2, setDocumentDetail2] = useState([]);
    const [code, setCode] = useState(null);
    const [isDocumentSelected, setIsDocumentSelected] = useState(false);
    const [isDocumentUploaded, setIsDocumentUploaded] = useState(false);
    const [emailValue, setEmailValue] = useState("");
    const [vatTaxValue, setVatTaxValue] = useState("");
    const [amountAedValue, setAmountAedValue] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [tradeLicense, setTradeLicense] = useState("");
    const [bankAccounts, setBankAccounts] = useState([]);
    const [selectedBankAccount, setSelectedBankAccount] = useState(null);
    const [supplierDetails, setSupplierDetails] = useState();
    const [uploadedFileName, setUploadedFileName] = useState("");
    const [bankList, setBankList] = useState([]);
    const [bankEntry, setBankEntry] = useState({ accountTitle: "", accountNumber: "", iban: "", swiftCode: "", country: "" });
    const [editingBankIndex, setEditingBankIndex] = useState(null);
    const [billingAddress, setBillingAddress] = useState({ address: "", city: "", state: "", country: "", zip: "" });
    const [showDraftErrors, setShowDraftErrors] = useState(false);
    // ─── Validation highlight states ───────────────────────────────────────────
    // step 0
    const [showStep0Errors, setShowStep0Errors] = useState(false);
    // step 1
    const [showStep1Errors, setShowStep1Errors] = useState(false);
    // step 2
    const [showStep2Errors, setShowStep2Errors] = useState(false);

    // Derived booleans for each required field
    const step0AuthorizePersonError = showStep0Errors && !getValues("authorizePerson");
    const step0EmailError = showStep0Errors && !emailValue;
    const step0PhoneError = showStep0Errors && !getValues("phone");

    const step1VatTaxError = showStep1Errors && !vatTaxValue;

    const step2BankError = showStep2Errors && !selectedBankAccount;
    const step2IbanError = showStep2Errors && !getValues("iban");
    const step2CreditDaysError = (showStep2Errors || showDraftErrors) && !getValues("creditDays");
    const step2AmountError = (showStep2Errors || showDraftErrors) && !amountAedValue;


    // ───────────────────────────────────────────────────────────────────────────

    const handleNext = () => {
        if (activeStep < 3) setActiveStep(activeStep + 1);
    };

    const allowFilesTypeInvoice = [
        "application/pdf",
    ];
    const handleUploadDocumentInvoices = async (e) => {
        try {
            e.preventDefault();

            setIsDocumentSelected(true);
            setIsDocumentUploaded(false);
            setUploadedFileName("");
            const file = e.target.files[0];
            let arr = [
                {
                    id: uuidv4(),
                    name: file?.name,
                    file: "",
                    type: file?.type.split("/")[1],
                    size: getFileSize(file.size),
                    isUpload: false,
                },
            ];
            if (allowFilesTypeInvoice.includes(file.type)) {
                setUploadedFileName(file?.name);
                setDocumentDetail2(arr);
                handleUploadInvoices(file, arr);

            } else {
                ErrorToaster(
                    `Only ${CleanTypes(allowFilesTypeInvoice)} formats is supported`,
                );
                e.target.value = "";
                setUploadedFileName("");
                setIsDocumentSelected(false);
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const handleUploadInvoices = async (file, docs) => {
        setProgress2(0);
        try {
            const formData = new FormData();
            formData.append("document", file);
            const { data } = await instance.post(routes.uploadDocuments, formData, {
                onUploadProgress: (progressEvent) => {
                    const uploadedBytes = progressEvent.loaded;
                    const percentCompleted = Math.round(
                        (uploadedBytes * 100) / progressEvent.total
                    );

                    setProgress2(percentCompleted);
                    setUploadedSize2(getFileSize(uploadedBytes));
                },
            });
            if (data) {
                docs[0].isUpload = true;
                docs[0].file = data?.data?.nations;
                setDocumentDetail2(docs);
                setDocumentLink2(data?.data?.nations);
                SuccessToaster("Document Uploaded");
                setIsDocumentUploaded(true);
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const handleAddDocument = () => {
        if (!documentLink2) {
            ErrorToaster("Please upload a document before adding.");
            return;
        }

        if (!selectedDocumentType?.id) return ErrorToaster("Please enter document Type");

        setDocumentList((prev) => [
            ...prev,
            {
                id: uuidv4(),
                doc_id: selectedDocumentType?.id,
                docType: selectedDocumentType?.name,
                documentLink2,
            },
        ]);
        SuccessToaster("Document Added");
        setSelectedDocumentType([]);
        setDocumentLink2("");
    };


    const handleLicenseDate = (newDate) => {
        try {
            if (newDate == "Invalid Date") {
                setLicenseDate("invalid");
                return;
            }
            setLicenseDate(new Date(newDate));
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const getBanks = async () => {
        try {
            let params = {
                page: 1,
                limit: 500
            }
            const { data } = await BankServices.getBanks(params)
            const banks = data?.banks?.rows
            setBankAccounts(banks)
            return banks;
        } catch (error) {
            ErrorToaster(error)
            return [];
        }
    }

    const handleAddBank = () => {
        const { accountTitle, accountNumber, iban, swiftCode, country } = bankEntry;
        if (!accountTitle && !iban) {
            ErrorToaster("Please enter at least Account Title or IBAN.");
            return;
        }
        if (editingBankIndex !== null) {
            setBankList((prev) => prev.map((b, i) => i === editingBankIndex ? { ...b, accountTitle, accountNumber, iban, swiftCode, country } : b));
            setEditingBankIndex(null);
            SuccessToaster("Bank account updated.");
        } else {
            setBankList((prev) => [...prev, { id: uuidv4(), accountTitle, accountNumber, iban, swiftCode, country }]);
            SuccessToaster("Bank account added.");
        }
        setBankEntry({ accountTitle: "", accountNumber: "", iban: "", swiftCode: "", country: "" });
    };

    const handleEditBank = (idx) => {
        const b = bankList[idx];
        setBankEntry({ accountTitle: b.accountTitle, accountNumber: b.accountNumber, iban: b.iban, swiftCode: b.swiftCode, country: b.country });
        setEditingBankIndex(idx);
    };

    const downloadAllAttachments = async (documentLinks) => {
        if (!documentLinks || documentLinks.trim() === "") {
            ErrorToaster("No attachments available.");
            return;
        }

        const filePath = documentLinks.trim();
        const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
        const fileExtension = filePath.split(".").pop();

        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", `attachment.${fileExtension}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(blobUrl);
            SuccessToaster("Downloading attachment...");
        } catch (error) {
            console.error("Download failed", error);
            ErrorToaster("Failed to download attachment.");
        }
    };


    // Form submission handlers
    const buildSupplierPayload = ({ isDraft }) => {
        return {
            supplier_id: id,
            company_name: companyName,
            authorized_person: getValues("authorizePerson"),
            email: emailValue,
            phone: getValues("phone"),
            remarks: getValues("remarks"),
            trade_license_no: tradeLicense,
            trade_license_expiry: licenseDate,
            vat_tax: vatTaxValue,
            supplier_banks: bankList.length > 0
                ? bankList.map(({ accountTitle, accountNumber, iban, swiftCode, country }) => ({
                    bank_name: accountTitle,
                    account_number: accountNumber,
                    bank_iban: iban,
                    swift_code: swiftCode,
                    country: country,
                    credit_days: getValues("creditDays"),
                    credit_amount: amountAedValue,
                }))
                : [{ credit_days: getValues("creditDays"), credit_amount: amountAedValue }],
         
                address: billingAddress.address,
                city: billingAddress.city,
                province: billingAddress.state,
                country: billingAddress.country,
                zip_postal: billingAddress.zip,
            
            amount: amountAedValue,
            credit_days: getValues("creditDays"),
            supplier_documents: documentList.map((d) => ({
                doc_id: d.doc_id,
                invoice_attachment: d.documentLink2,
            })),
            is_draft: Boolean(isDraft),
        };
    };

const submitSupplier = async ({ isDraft }) => {
if (isDraft) {
    if (!getValues("creditDays") || !amountAedValue || Number(amountAedValue) <= 0) {
        if (Number(amountAedValue) <= 0) {
            ErrorToaster("Amount must be greater than 0.");
        } else {
            ErrorToaster("Please enter Credit Days and Credit Limit to save draft.");
        }
        setShowDraftErrors(true);
        setActiveStep(2);
        return;
    }
}

  if (!isDraft) {
    // Step 0
    if (!companyName || !getValues("authorizePerson") || !emailValue || !getValues("phone")) {
      setShowStep0Errors(true);
      setActiveStep(0);
      ErrorToaster("Please fill all required fields in Company Info.");
      return;
    }
    setShowStep0Errors(false);

    // Step 1
    if (!vatTaxValue) {
      setShowStep1Errors(true);
      setActiveStep(1);
      ErrorToaster("Please fill all required fields in License & Tax Info.");
      return;
    }
    setShowStep1Errors(false);

    // Step 2
    if (!amountAedValue || Number(amountAedValue) <= 0 || !getValues("creditDays")) {
        if (Number(amountAedValue) <= 0) {
            ErrorToaster("Amount must be greater than 0.");
        } else {
            ErrorToaster("Please fill Credit Amount and Credit Days in Bank Info.");
        }
        setShowStep2Errors(true);
        setActiveStep(2);
        return;
    }
    setShowStep2Errors(false);
  }

  setLoader(true);
  try {
    const payload = buildSupplierPayload({ isDraft });
    const response = await SupplierServices.editSupplier(payload);
    if (response?.responseCode === 200) {
      SuccessToaster(isDraft ? "Draft Updated successfully." : "Supplier Updated successfully.");
      navigate("/supplier-listing");
    } else {
      ErrorToaster(isDraft ? "Failed to update draft." : "Failed to Update supplier.");
    }
  } catch (error) {
    ErrorToaster(error);
    console.error("Submit error:", error);
  } finally {
    setLoader(false);
  }}

    const handleSaveDraft = async () => {
        await submitSupplier({ isDraft: true });
    };

    const handleSubmitForm = async () => {
        await submitSupplier({ isDraft: false });
        
    };

    const getSupplierDataDetails = async (banks = []) => {
        try {
            let params = { supplier_id: id };
            const data = await SupplierServices.getSupplierDetail(params);
            console.log(data, '.......');
            const supplier = data?.data?.supplier;

            if (supplier) {
                setValue("companyName", supplier?.company_name);
                setCompanyName(supplier?.company_name)
                setValue("authorizePerson", supplier?.authorized_person);
                setValue("masterEmail", supplier?.email);
                setEmailValue(supplier?.email);
                setValue("phone", supplier?.phone);
                setValue("remarks", supplier?.remarks);
                setValue("tradeLicense", supplier?.trade_license_no);
                setTradeLicense(supplier?.trade_license_no)
                setValue("vatTax", supplier?.vat_tax);
                setVatTaxValue(supplier?.vat_tax);
                handleLicenseDate(supplier?.trade_license_expiry)
                const firstBank = supplier?.supplier_banks?.[0];
                const creditAmount = firstBank?.credit_amount ?? supplier?.amount;
                const creditDays = firstBank?.credit_days ?? supplier?.credit_days;
                setValue("amountAed", creditAmount);
                setAmountAedValue(String(creditAmount ?? ""));
                setValue("creditDays", creditDays);
                if (supplier?.supplier_banks?.length) {
                    setBankList(supplier.supplier_banks.map((b) => ({
                        id: uuidv4(),
                        accountTitle: b.bank_name || "",
                        accountNumber: b.account_number || "",
                        iban: b.bank_iban || "",
                        swiftCode: b.swift_code || "",
                        country: b.country || "",
                    })));
                }
                setBillingAddress({
                    address: supplier.address || "",
                    city: supplier.city || "",
                    state: supplier.province || "",
                    country: supplier.country || "",
                    zip: supplier.zip_postal || "",
                });

                if (
                    supplier?.supplier_documents &&
                    Array.isArray(supplier?.supplier_documents)
                ) {
                    const invoiceData = supplier?.supplier_documents.map((invoice) => ({
                        id: invoice?.id,
                        doc_id: invoice?.doc_id,
                        docType: invoice?.doc_id === 1 ? "Trade License" : "TAX Certificate",
                        documentLink2: invoice?.invoice_attachment,
                    }));
                    setDocumentList(invoiceData || []);
                }
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };

    useEffect(() => {
        const init = async () => {
            const banks = await getBanks();
            await getSupplierDataDetails(banks);
        };
        init();
    }, []);


    const renderForm = () => {
        switch (activeStep) {
            case 0:
                return (
                    <>
                        <Typography
                            sx={{
                                fontFamily: FontFamily.Halvetica,
                                fontSize: "22px",
                                fontWeight: 700,
                                fontStyle: "Bold",
                                mb: 1.5,
                            }}
                        >
                            Company Info
                        </Typography>

                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6}>
                                <InputField
                                    size={"small"}
                                    label={"Company Name"}
                                    placeholder={"Company Name"}
                                    error={errors?.companyName?.message}
                                    register={register("companyName")}
                                    value={companyName}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputField
                                    size={"small"}
                                    label={"Authorized Person *"}
                                    placeholder={"Enter Authorized Person"}
                                    register={register("authorizePerson", {
                                        required: "Authorize person name is required.",
                                    })}
                                    error={errors?.authorizePerson?.message || (step0AuthorizePersonError ? "Authorized Person is required." : "")}
                                    sx={step0AuthorizePersonError ? errorBorderSx : {}}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputField
                                    size={"small"}
                                    label={"Email *"}
                                    type="email"
                                    placeholder={"Email"}
                                    error={errors?.masterEmail?.message || (step0EmailError ? "Email is required." : "")}
                                    register={register("masterEmail", {
                                        required: "Please enter your email.",
                                        pattern: {
                                            value: emailRegex,
                                            message: "Please enter a valid email.",
                                        },
                                        onChange: (e) => setEmailValue(e.target.value),
                                    })}
                                    value={emailValue}
                                    sx={step0EmailError ? errorBorderSx : {}}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {/* Phone wrapper: add red border via a wrapping Box when invalid */}
                                <Box
                                    sx={
                                        step0PhoneError
                                            ? {
                                                "& .react-tel-input .form-control": {
                                                    borderColor: "red !important",
                                                },
                                                "& .react-tel-input .flag-dropdown": {
                                                    borderColor: "red !important",
                                                },
                                                "& label": { color: "red" },
                                            }
                                            : {}
                                    }
                                >
                                    <InputPhone
                                        label="Phone *"
                                        name="phone"
                                        control={control}
                                        size={"small"}
                                        error={errors?.phone?.message || (step0PhoneError ? "Phone number is required." : "")}
                                        onBlur={(e, v) => {
                                            console.log(v, 'vvv');
                                            if (v && v.dialCode) {
                                                setCode(v.dialCode);
                                            } else {
                                                console.error('Dial code is undefined');
                                            }
                                        }}
                                        rules={{
                                            required: "Please enter your phone number.",
                                        }}
                                        borderRadius="12px"
                                        height="45px"
                                    />
                                </Box>
                                {/* {step0PhoneError && (
                                    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5, ml: 1.5 }}>
                                        Phone number is required.
                                    </Typography>
                                )} */}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputField
                                    label={"Remarks"}
                                    placeholder={"Enter remarks here..."}
                                    register={register("remarks")}
                                    multiline={true}
                                    rows={3}
                                />
                            </Grid>
                        </Grid>
                    </>
                );
            case 1:
                return (
                    <>
                        <Typography sx={{
                            fontFamily: FontFamily.Halvetica,
                            fontSize: "22px",
                            fontWeight: 700,
                            fontStyle: "Bold",
                            mb: 1.5,
                        }}>License & Tax Info Form</Typography>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6}>
                                <InputField
                                    size={"small"}
                                    label={"Trade License"}
                                    placeholder={"Enter Trade License"}
                                    error={errors?.tradeLicense?.message}
                                    register={register("tradeLicense", {
                                        onChange: (e) => setTradeLicense(e.target.value),
                                    })}
                                    value={tradeLicense}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <DatePicker
                                    label={"Trade License Expiry"}
                                    minDate={new Date()}
                                    size="small"
                                    value={licenseDate}
                                    onChange={handleLicenseDate}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputField
                                    size={"small"}
                                    label={"VAT/TAX *"}
                                    placeholder={"VAT/TAX*"}
                                    error={errors?.vatTax?.message || (step1VatTaxError ? "VAT/TAX is required." : "")}
                                    register={register("vatTax", {
                                        onChange: (e) => setVatTaxValue(e.target.value),
                                    })}
                                    value={vatTaxValue}
                                    sx={step1VatTaxError ? errorBorderSx : {}}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}></Grid>
                            <Grid item xs={12} sm={3}>
                                <SelectField
                                    label="Document Type"
                                    options={[
                                        { id: 1, name: "Trade License" },
                                        { id: 2, name: "TAX Certificate" },
                                    ]}
                                    selected={selectedDocumentType}
                                    onSelect={(value) => {
                                        setSelectedDocumentType(value);
                                    }}
                                    register={register("periodicInvoice")}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3} mt={3.7}>
                                <UploadFile
                                    custom={true}
                                    vendor={true}
                                    style={{
                                        backgroundColor: "#e7efeb",
                                        width: "100%",
                                        height: "40px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10px 8px",
                                        border: "1px dashed #aeb1b0",
                                        borderRadius: "10px",
                                    }}
                                    register={register("scanned", {
                                        onChange: (e) => handleUploadDocumentInvoices(e),
                                    })}
                                />
                                {uploadedFileName && (
                                    <Typography
                                        sx={{
                                            fontSize: "12px",
                                            color: Colors.primary,
                                            mt: 0.8,
                                            ml: 0.5,
                                            wordBreak: "break-all",
                                        }}
                                    >
                                        📄 {uploadedFileName}
                                    </Typography>)}
                            </Grid>
                            <Grid item xs={12} sm={1} sx={{ textAlign: "right" }} mt={4}>
                                <IconButton
                                    size="small"
                                    onClick={handleAddDocument}
                                    sx={{
                                        bgcolor: Colors.primary,
                                        color: Colors.white,
                                        "&:hover": {
                                            bgcolor: Colors.primary,
                                            color: Colors.white,
                                        },
                                    }}
                                >
                                    <Add />
                                </IconButton>
                            </Grid>
                            {documentList.length > 0 ? (
                                <Grid item xs={12} sm={12}>
                                    <TableContainer component={Paper}>
                                        <Table sx={{ minWidth: 650 }} aria-label="Documents Table">
                                            <TableHead sx={{ bgcolor: Colors.primary, color: Colors.white }}>
                                                <TableRow>
                                                    <Cell>Document Type</Cell>
                                                    <Cell>Attachment</Cell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {documentList.map((doc) => (
                                                    <TableRow key={doc?.id}>
                                                        <TableCell>{doc?.docType}</TableCell>
                                                        <TableCell>
                                                            {doc?.documentLink2 ? (
                                                                <div
                                                                    style={{ cursor: "pointer", marginLeft: "14px" }}
                                                                    onClick={() => downloadAllAttachments(doc?.documentLink2)}
                                                                >
                                                                    <FiDownload color={Colors.primary} size={25} />
                                                                </div>
                                                            ) : (
                                                                <FiDownload color="gray" size={25} />
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            ) : null}
                        </Grid>
                    </>
                );
            case 2:
                return (
                    <>
                        <Typography sx={{ fontFamily: FontFamily.Halvetica, fontSize: "22px", fontWeight: 700, fontStyle: "Bold", mb: 1.5 }}>Bank Info</Typography>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6}>
                                <InputField size={"small"} label={"Account Title"} placeholder={"Enter Account Title"}
                                    value={bankEntry.accountTitle}
                                    register={register("accountTitle", { onChange: (e) => setBankEntry((p) => ({ ...p, accountTitle: e.target.value })) })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputField size={"small"} label={"Account Number"} placeholder={"Enter Account Number"}
                                    value={bankEntry.accountNumber}
                                    register={register("accountNumber", { onChange: (e) => setBankEntry((p) => ({ ...p, accountNumber: e.target.value })) })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputField size={"small"} label={"IBAN"} placeholder={"Enter IBAN"}
                                    value={bankEntry.iban}
                                    register={register("iban", { onChange: (e) => setBankEntry((p) => ({ ...p, iban: e.target.value })) })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputField size={"small"} label={"Swift Code"} placeholder={"Enter Swift Code"}
                                    value={bankEntry.swiftCode}
                                    register={register("swiftCode", { onChange: (e) => setBankEntry((p) => ({ ...p, swiftCode: e.target.value })) })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <InputField size={"small"} label={"Country"} placeholder={"Enter Country"}
                                    value={bankEntry.country}
                                    register={register("bankCountry", { onChange: (e) => setBankEntry((p) => ({ ...p, country: e.target.value })) })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={1} sx={{ display: "flex", alignItems: "center", justifyContent: "center", mt: 1, gap: 1 }}>
                                <IconButton size="small" onClick={handleAddBank}
                                    sx={{ bgcolor: Colors.primary, color: Colors.white, "&:hover": { bgcolor: Colors.primary } }}>
                                    {editingBankIndex !== null ? <CheckIcon /> : <Add />}
                                </IconButton>
                                {editingBankIndex !== null && (
                                    <IconButton size="small" onClick={() => { setEditingBankIndex(null); setBankEntry({ accountTitle: "", accountNumber: "", iban: "", swiftCode: "", country: "" }); }}
                                        sx={{ bgcolor: "grey.400", color: Colors.white, "&:hover": { bgcolor: "grey.500" } }}>✕</IconButton>
                                )}
                            </Grid>

                            {bankList.length > 0 && (
                                <Grid item xs={12}>
                                    <TableContainer component={Paper} sx={{ mt: 1 }}>
                                        <Table size="small">
                                            <TableHead sx={{ bgcolor: Colors.primary }}>
                                                <TableRow>
                                                    {["#", "Account Title", "Account No.", "IBAN", "Swift", "Country", "", ""].map((h, i) => (
                                                        <Cell key={i}>{h}</Cell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {bankList.map((b, idx) => (
                                                    <TableRow key={b.id}>
                                                        <TableCell>{idx + 1}</TableCell>
                                                        <TableCell>{b.accountTitle || "-"}</TableCell>
                                                        <TableCell>{b.accountNumber || "-"}</TableCell>
                                                        <TableCell>{b.iban || "-"}</TableCell>
                                                        <TableCell>{b.swiftCode || "-"}</TableCell>
                                                        <TableCell>{b.country || "-"}</TableCell>
                                                        <TableCell>
                                                            <IconButton size="small" onClick={() => handleEditBank(idx)} sx={{ color: Colors.primary }}><EditIcon fontSize="small" /></IconButton>
                                                        </TableCell>
                                                        <TableCell>
                                                            <IconButton size="small" onClick={() => setBankList((prev) => prev.filter((_, i) => i !== idx))} sx={{ color: "red" }}>✕</IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            )}

                            <Grid item xs={12} sm={6}>
                                <InputField size={"small"} label={"Credit Amount (د.إ)"} placeholder={"Enter Amount د.إ"}
                                    value={amountAedValue}
                                    register={register("amountAed", {
                                        required: "Amount Required",
                                        onChange: (e) => {
                                            let v = e.target.value.replace(/,/g, "").replace(/[^0-9.]/g, "");
                                            const parts = v.split(".");
                                            if (parts.length > 2) v = parts[0] + "." + parts[1];
                                            if (parts[1]?.length > 2) v = parts[0] + "." + parts[1].slice(0, 2);
                                            if (v !== "" && Number(v) <= 0) { ErrorToaster("Amount must be greater than 0."); return; }
                                            e.target.value = v;
                                            setAmountAedValue(v);
                                        },
                                    })}
                                    error={errors?.amountAed?.message || (step2AmountError ? "Amount is required." : "")}
                                    sx={step2AmountError ? errorBorderSx : {}}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputField size={"small"} label={"Credit Days *"} placeholder={"Enter Credit Days"}
                                    register={register("creditDays", { required: "Credit Days is required." })}
                                    error={errors?.creditDays?.message || (step2CreditDaysError ? "Credit Days is required." : "")}
                                    sx={step2CreditDaysError ? errorBorderSx : {}}
                                />
                            </Grid>
                        </Grid>
                    </>
                );
            case 3:
                return (
                    <>
                        <Typography sx={{ fontFamily: FontFamily.Halvetica, fontSize: "22px", fontWeight: 700, fontStyle: "Bold", mb: 1.5 }}>Billing Address</Typography>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6}>
                                <InputField size={"small"} label={"Address"} placeholder={"Enter Address"}
                                    value={billingAddress.address}
                                    register={register("billingAddress", { onChange: (e) => setBillingAddress((p) => ({ ...p, address: e.target.value })) })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputField size={"small"} label={"City"} placeholder={"Enter City"}
                                    value={billingAddress.city}
                                    register={register("billingCity", { onChange: (e) => setBillingAddress((p) => ({ ...p, city: e.target.value })) })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputField size={"small"} label={"State / Province"} placeholder={"Enter State"}
                                    value={billingAddress.state}
                                    register={register("billingState", { onChange: (e) => setBillingAddress((p) => ({ ...p, state: e.target.value })) })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputField size={"small"} label={"Country"} placeholder={"Enter Country"}
                                    value={billingAddress.country}
                                    register={register("billingCountry2", { onChange: (e) => setBillingAddress((p) => ({ ...p, country: e.target.value })) })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputField size={"small"} label={"ZIP / Postal Code"} placeholder={"Enter ZIP"}
                                    value={billingAddress.zip}
                                    register={register("billingZip", { onChange: (e) => setBillingAddress((p) => ({ ...p, zip: e.target.value })) })}
                                />
                            </Grid>
                        </Grid>
                    </>
                );
        }
    };

    return (
        <Box sx={{ m: 4, mb: 8 }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 4,
                    mt: 4,
                }}
            >
                <Typography
                    variant="h5"
                    sx={{
                        color: "#094526",
                        fontFamily: FontFamily.Halvetica,
                        fontSize: "32px",
                        fontWeight: 700,
                        fontStyle: "Bold",
                    }}
                >
                    Edit Supplier
                </Typography>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12} md={3.5}>
                    <CustomPaper
                        sx={{
                            borderRadius: "6px",
                            border: `1px solid ${Colors.grey}`,
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            padding: "0px !important",
                            margin: "0px !important",
                        }}
                    >
                        <Box sx={{
                            padding: "0px !important",
                            borderLeft: activeStep === 0 ? "6px solid #5BBC0F" : "transparent",
                        }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                    marginTop: "15px",
                                    marginBottom: "15px",
                                }}
                            >
                                <IconButton
                                    sx={{
                                        backgroundColor: "transparent",
                                        color: activeStep === 0 ? "#5BBC0F" : Colors.grey,
                                        border: "1px solid",
                                        borderColor: activeStep === 0 ? "#5BBC0F" : Colors.grey,
                                        borderRadius: "50%",
                                        width: "40px",
                                        height: "40px",
                                        padding: 1,
                                        marginLeft: "20px",
                                    }}
                                    onClick={() => setActiveStep(0)}
                                >
                                    <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>01</Typography>
                                </IconButton>
                                <Typography
                                    sx={{
                                        color: activeStep === 0 ? "#5BBC0F" : Colors.grey,
                                        fontWeight: 700,
                                        fontSize: "16px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setActiveStep(0)}
                                >
                                    Company Info
                                </Typography>
                            </Box>
                        </Box>

                        <Divider sx={{ borderColor: Colors.grey }} />

                        <Box sx={{
                            borderLeft: activeStep === 1 ? "6px solid #5BBC0F" : "transparent",
                            padding: "0px !important",
                        }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                    marginTop: "15px",
                                    marginBottom: "15px",
                                }}
                            >
                                <IconButton
                                    sx={{
                                        backgroundColor: "transparent",
                                        color: activeStep === 1 ? "#5BBC0F" : Colors.grey,
                                        border: "1px solid",
                                        borderColor: activeStep === 1 ? "#5BBC0F" : Colors.grey,
                                        borderRadius: "50%",
                                        width: "40px",
                                        height: "40px",
                                        padding: 1,
                                        marginLeft: "20px",
                                    }}
                                    onClick={() => setActiveStep(1)}
                                >
                                    <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>02</Typography>
                                </IconButton>
                                <Typography
                                    sx={{
                                        color: activeStep === 1 ? "#5BBC0F" : Colors.grey,
                                        fontWeight: 700,
                                        fontSize: "16px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setActiveStep(1)}
                                >
                                    License & Tax Info
                                </Typography>
                            </Box>
                        </Box>

                        <Divider sx={{ borderColor: Colors.grey, margin: "0px !important" }} />

                        <Box sx={{
                            borderLeft: activeStep === 2 ? "6px solid #5BBC0F" : "transparent",
                            padding: "0px !important",
                        }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                    marginBottom: "15px",
                                    marginTop: "15px",
                                }}
                            >
                                <IconButton
                                    sx={{
                                        backgroundColor: "transparent",
                                        color: activeStep === 2 ? "#5BBC0F" : Colors.grey,
                                        border: "1px solid",
                                        borderColor: activeStep === 2 ? "#5BBC0F" : Colors.grey,
                                        borderRadius: "50%",
                                        width: "40px",
                                        height: "40px",
                                        padding: 1,
                                        marginLeft: "20px",
                                    }}
                                    onClick={() => setActiveStep(2)}
                                >
                                    <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>03</Typography>
                                </IconButton>
                                <Typography
                                    sx={{
                                        color: activeStep === 2 ? "#5BBC0F" : Colors.grey,
                                        fontWeight: 700,
                                        fontSize: "16px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setActiveStep(2)}
                                >
                                    Bank Info
                                </Typography>
                            </Box>
                        </Box>

                        <Divider sx={{ borderColor: Colors.grey, margin: "0px !important" }} />

                        <Box sx={{
                            borderLeft: activeStep === 3 ? "6px solid #5BBC0F" : "transparent",
                            padding: "0px !important",
                        }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                    marginBottom: "15px",
                                    marginTop: "15px",
                                }}
                            >
                                <IconButton
                                    sx={{
                                        backgroundColor: "transparent",
                                        color: activeStep === 3 ? "#5BBC0F" : Colors.grey,
                                        border: "1px solid",
                                        borderColor: activeStep === 3 ? "#5BBC0F" : Colors.grey,
                                        borderRadius: "50%",
                                        width: "40px",
                                        height: "40px",
                                        padding: 1,
                                        marginLeft: "20px",
                                    }}
                                    onClick={() => setActiveStep(3)}
                                >
                                    <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>04</Typography>
                                </IconButton>
                                <Typography
                                    sx={{
                                        color: activeStep === 3 ? "#5BBC0F" : Colors.grey,
                                        fontWeight: 700,
                                        fontSize: "16px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setActiveStep(3)}
                                >
                                    Billing Address
                                </Typography>
                            </Box>
                        </Box>
                    </CustomPaper>
                </Grid>

                <Grid item xs={12} md={8}>
                    {renderForm()}
                </Grid>
            </Grid>
            {activeStep === 0 && (
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}>
                    <PrimaryButton onClick={handleNext} title={"Next"} />
                </Box>
            )}

            {activeStep === 1 && (
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}>
                    <PrimaryButton onClick={() => setActiveStep(activeStep - 1)} title={"Back"} />
                    <PrimaryButton onClick={handleNext} title={"Next"} />
                </Box>
            )}

            {activeStep === 2 && (
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}>
                    <PrimaryButton onClick={() => setActiveStep(activeStep - 1)} title={"Back"} bgcolor={Colors.grey} />
                    <PrimaryButton onClick={handleNext} title={"Next"} />
                </Box>
            )}

            {activeStep === 3 && (
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}>
                    <PrimaryButton onClick={() => setActiveStep(activeStep - 1)} title={"Back"} bgcolor={Colors.grey} />
                    <PrimaryButton onClick={handleSaveDraft} title={"Save as Draft"} bgcolor={Colors.grey} />
                    <PrimaryButton onClick={handleSubmitForm} title={"Update"} loading={loader} />
                </Box>
            )}
        </Box>
    );
}

export default EditSupplier;